import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/home/Home'
import Apartments from '../components/apartments/Apartments'
import digitalresources from '../components/digitalResources/digitalResources'
import childCarePrograms from '../components/childCarePrograms/childCarePrograms'
import parkAccessibility from '../components/parksAccessibility/parksAccessibility'
import foodResources from '../components/foodResources/foodResources'
import map from '../components/strapi/map'
import Projects from '../components/projects/Projects'
import Project from '../components/projects/Project'
import polling from '../components/pollingPlaces/Polling'
import Search from '../components/projects/Search'
import NotFound from '../components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/apartments',
      name: 'Apartments',
      component: Apartments
    },
    {
      path: '/digitalresources',
      name: 'digitalResources',
      component: digitalresources
    },
    {
      path: '/childcareprograms',
      name: 'childcareprograms',
      component: childCarePrograms
    },
    {
      path: '/parkaccessibility',
      name: 'parkaccessibility',
      component: parkAccessibility
    },
    {
      path: '/foodresources',
      name: 'foodresources',
      component: foodResources
    },
    {
      path: '/map/:slug',
      name: 'map',
      component: map
    },
    {
      path: '/polling',
      name: 'polling',
      component: polling
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      props: (route) => ({
        queryStatus: route.query.status,
        querySubStatus: route.query.subStatus,
        queryProjectType: route.query.type
      })
    },
    {
      path: '/dailywork',
      name: 'DailyWork',
      component: Projects,
      props: (route) => ({
        queryStatus: route.query.status,
        querySubStatus: route.query.subStatus,
        queryProjectType: route.query.type
      })
    },
    {
      path: '/projects/:id',
      name: 'Project',
      component: Project
    },
    {
      path: '/search/',
      name: 'Projects Search',
      component: Search
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js